import MuiDialogTitle, { DialogTitleProps } from "@mui/material/DialogTitle";

const DialogTitle: React.FC<DialogTitleProps> = MuiDialogTitle;

export default DialogTitle;
export type { DialogTitleProps };
